import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table, Form } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  DatatableWrapper,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { formatDate } from "../../utils/helper";
import { ROUTES } from "../../constants/webRouting";

const CourseRegistrationList = ({ dateRange }) => {
  const [body, setBody] = useState([]);

  useEffect(() => {
    init(dateRange);
  }, [dateRange]);

  async function init() {
    const filterDate = {};
    if (Array.isArray(dateRange)) {
      const [fromDate, toDate] = dateRange;
      if (fromDate && toDate) {
        filterDate.fromDate = formatDate(fromDate);
        filterDate.toDate = formatDate(toDate);
      }
    }
    const leadLostRec = await fuziElevatorsApi.fetchLeadNotConverted(Object.keys(filterDate).length > 0 ? filterDate : null);
    if (leadLostRec) {
      setBody(leadLostRec);
    } else {
      setBody([]);
    }

  }

  const header = [
    {
      title: "Lead_Name",
      prop: "lead_name",
      isFilterable: true,
      cell: (row) => (
        <Link to={`${ROUTES.LEAD.LIST}/${row.id}`} state={row}>
          {row.lead_name}
        </Link>
      ),
    },
    { title: "Phone", prop: "phone" },
    { title: "Lost Reason", prop: "lead_lost_remark" },

    { title: "Status", prop: "lead_status", isFilterable: true, isSortable: true },
    {
      title: "Owner Name", prop: "owner_name",
      cell: (row) => (
        <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`}>
          {row.owner_name}
        </Link>
      ),
    },
    // {
    //   title: 'Actions', prop: 'id', cell: (row) => (
    //     <Button
    //     className="btn-sm"
    //     variant="primary"
    //     onClick={() => ShowChequeDetails(row)}
    //   >
    //     Get Details
    //   </Button>
    //   )
    // }
  ];

  // const labels = {
  //   beforeSelect: " ",
  // };

  //eslint-disable-next-line

  return (
    // <Main>
    <div>
      <Row className="g-0">
        <Col lg={12} >
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 2,
                  options: [5, 10, 15, 20, 30],
                },
              }}
              sortProps={{
                initialState: {
                  sort: "leadname",
                  order: "desc",
                },
              }}
            >
              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              {body.length > 2 && <Pagination />}
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </div>
  );
};
export default CourseRegistrationList;
